import * as css from './buttonIcon.css';

function ButtonIcon ({iconName = '', text = '', onClick=(e: any)=>e, BGColor = '', children = null, ...moreProps}){
    return (
        <css.button BGColor={BGColor} icon={iconName} onClick={onClick} {...moreProps} >{text}{children}</css.button>
    );
}
export default ButtonIcon;